<form [formGroup]="filterForm">

  <ng-container *ngIf="mediaService.desktop$ | async as desktop; else mobile">

    <div class="filter-header">

      <!-- search field -->
      <mat-form-field class="search-form" floatLabel="never" [ngClass.gt-sm]="{ desktop: true }">
        <mat-label>{{ 'SEARCH.INPUT_SEARCH_PLACEHOLDER' | translate }}</mat-label>
        <input matInput #message maxlength="256" formControlName="query" name="filter-query">
        <mat-icon matSuffix svgIcon="search"></mat-icon>
      </mat-form-field>

      <!-- warehouse -->
      <mat-form-field class="filter-item warehouse" appearance="standard">
        <mat-select [placeholder]="'FILTER.TEXT_WAREHOUSE' | translate" formControlName="warehouse"
          matTooltip="{{ 'FILTER.TOOLTIP_WAREHOUSE' | translate }}" matTooltipPosition="above"
          matTooltipClass="tooltip">
          <mat-option [value]="">{{ 'FILTER.OPTION_ALL' | translate }}</mat-option>
          <mat-option *ngFor="let warehouse of terminalsApiService.warehouses$ | async" [value]="warehouse.code">{{
            warehouse.name }} ({{ warehouse.code }})</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- certificate -->
      <mat-form-field class="filter-item" appearance="standard">
        <mat-select [placeholder]="'FILTER.TEXT_CERTIFICATE_TYPE' | translate" formControlName="certificate"
          matTooltip="{{ 'FILTER.TOOLTIP_CERTIFICATE' | translate }}" matTooltipPosition="above"
          matTooltipClass="tooltip">
          <mat-option [value]="">{{ 'FILTER.OPTION_ALL' | translate }}</mat-option>
          <mat-option [value]="FILTER_NO_CERTIFICATE">{{ 'FILTER.OPTION_NO_CERTIFICATE' | translate }}</mat-option>
          <mat-option *ngFor="let cert of codesApiService.certificates$ | async" [value]="cert.value">{{ cert.name
            }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- checkboxes: landed, not landed, single length -->
      <div class="filter-group">
        <mat-checkbox class="button" formControlName="showLanded" (change)="toggleCheckbox('showLanded')"
        matTooltip="{{ 'FILTER.TOOLTIP_LANDED' | translate }}" matTooltipPosition="above" matTooltipClass="tooltip">
          <mat-icon [svgIcon]="filterForm.get('showLanded')?.value ? 'landed-selected' : 'landed'"></mat-icon>
        </mat-checkbox>
        <mat-checkbox class="button" formControlName="showNotLanded" (change)="toggleCheckbox('showNotLanded')"
          matTooltip="{{ 'FILTER.TOOLTIP_NOT_LANDED' | translate }}" matTooltipPosition="above" matTooltipClass="tooltip">
          <mat-icon [svgIcon]="filterForm.get('showNotLanded')?.value ? 'not-landed-selected' : 'not-landed'"></mat-icon>
        </mat-checkbox>        
        <mat-checkbox class="button" formControlName="showSingleLength"
          matTooltip="{{ 'FILTER.TOOLTIP_SINGLE_LENGTH' | translate }}" matTooltipPosition="above"
          matTooltipClass="tooltip">
          <mat-icon [svgIcon]="showSingleLength ? 'single-length-selected' : 'single-length'"></mat-icon>
        </mat-checkbox>
      </div>

      <!-- length filters -->
      <div class="filter-group small">
        <mat-form-field class="filter-item" appearance="standard">
          <mat-select formControlName="minLength" [placeholder]="'FILTER.MIN_LENGTH' | translate"
            matTooltip="{{ 'FILTER.TOOLTIP_MIN_LENGTH' | translate }}" matTooltipPosition="above"
            matTooltipClass="tooltip">
            <mat-option *ngFor="let length of packetLengths" [value]="length">{{length}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="filter-item" appearance="standard">
          <mat-select formControlName="maxLength" [placeholder]="'FILTER.MAX_LENGTH' | translate"
            matTooltip="{{ 'FILTER.TOOLTIP_MAX_LENGTH' | translate }}" matTooltipPosition="above"
            matTooltipClass="tooltip">
            <mat-option *ngFor="let length of packetLengths" [value]="length">{{length}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- reset filters -->
      <button mat-flat-button color="accent" class="reset" (click)="reset()">
        {{ 'FILTER.TEXT_RESET' | translate }}
      </button>

      <!--download icon-->
      <div>
        <a mat-icon-button class="download" color="primary" aria-label="Download" (click)="downloadCSV()">
          <mat-icon matTooltip="{{ 'FILTER.TOOLTIP_DOWNLOAD' | translate }}" matTooltipPosition="above"
          matTooltipClass="tooltip">get_app</mat-icon>
        </a>
      </div>

    </div>

  </ng-container>

  <!-- mobile view: put <app-filter> inside the <app-footer> component too -->
  <ng-template #mobile>

    <div class="filter-footer">

      <button mat-icon-button class="filter" (click)="openDialog()">
        <mat-icon svgIcon="filter"> </mat-icon>
      </button>

      <!-- Search Field -->
      <mat-form-field floatLabel="never" class="search-form" [ngClass.gt-sm]="{ desktop: false }">
        <mat-label>{{ 'SEARCH.INPUT_SEARCH_PLACEHOLDER' | translate }}</mat-label>
        <input matInput #message maxlength="256" formControlName="query" style="width: 100%;">
        <mat-icon svgIcon="search" matSuffix></mat-icon>
      </mat-form-field>

    </div>

  </ng-template>

</form>